import React from "react";
import { Link } from "react-router-dom";

function RelatedPostThumbnail({ post }) {
  const parsedTags = post?.tags?.map((tag) => `#${tag}`).join(", ");
  return (
    <div className="card">
      <Link to={`/details/${post?.id}`}>
        <img src={post?.image} className="card-image" alt="" />
      </Link>
      <div className="p-4">
        <Link
          to={`/details/${post?.id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {post?.title}
        </Link>
        <div className="mb-0 tags">
          {parsedTags}
          {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
        </div>
        <p>{post?.createdAt}</p>
      </div>
    </div>
  );
}

export default RelatedPostThumbnail;
